import * as v from "valibot";

const fieldsSchema = v.nullish(
  v.array(
    v.object({
      field: v.nullish(v.string()),
      value: v.nullish(v.string()),
      errors: v.nullish(
        v.array(
          v.object({
            code: v.nullish(v.string()),
            message: v.nullish(v.string()),
            exception: v.nullish(v.string()),
          }),
        ),
      ),
    }),
  ),
);
export type Fields = v.InferOutput<typeof fieldsSchema>;

export const userSchema = v.nullish(
  v.object({
    isAuthenticated: v.nullish(v.boolean()),
    email: v.nullish(v.string()),
    emailVerified: v.nullish(v.boolean()),
    hasPassword: v.nullish(v.boolean()),
    firstName: v.nullish(v.string()),
    lastName: v.nullish(v.string()),
  }),
);
export type User = v.InferOutput<typeof userSchema>;

export const PageSchema = v.nullish(
  v.object({
    errors: v.nullish(
      v.array(
        v.object({
          code: v.string(),
          message: v.string(),
        }),
      ),
    ),
    fields: fieldsSchema,
    externalProviders: v.nullish(
      v.array(
        v.object({
          authenticationScheme: v.picklist([
            "Google",
            "Facebook",
            "Apple",
            "Twitter",
          ]),
        }),
      ),
    ),
    antiForgery: v.nullish(
      v.object({
        token: v.string(),
        fieldName: v.string(),
      }),
    ),
    language: v.string(),
    supportedLanguages: v.array(v.string()),
    returnUrl: v.nullish(
      v.object({
        token: v.string(),
        fieldName: v.string(),
      }),
    ),
    user: userSchema,
    clientId: v.string(),
  }),
);
export type WindowModel = v.InferOutput<typeof PageSchema>;

declare global {
  interface Window {
    model: WindowModel;
  }
}

export function getGlobals(): WindowModel {
  if (typeof window === "undefined") {
    // Used at prerendering
    return {
      clientId: "",
      language: "",
      supportedLanguages: ["en", "fr"],
    };
  }

  if (import.meta.env.DEV) {
    return {
      fields: [{ field: "email", errors: [] }],
      externalProviders: [
        { authenticationScheme: "Google" },
        { authenticationScheme: "Facebook" },
        { authenticationScheme: "Apple" },
        { authenticationScheme: "Twitter" },
      ],
      antiForgery: {
        token: "test",
        fieldName: "test",
      },
      language: "fr",
      returnUrl: {
        token: "test",
        fieldName: "test",
      },
      user: {
        isAuthenticated: false,
        emailVerified: false,
        hasPassword: false,
      },
      supportedLanguages: ["en", "fr"],
      clientId: "frontend",
    };
  }

  const result = v.safeParse(PageSchema, window.model);

  if (!result.success) {
    console.error(result.output);
    throw new Error("Invalid window model");
  }

  return result.output;
}
